export const EMPLOYEE_EMPLOYMENT_PAGE = {
  EMPLOYMENT_INFO: "employment_info",
  SHIFT_INFO: "shift_info",
  CHAIN_OF_COMMAND: "chain_of_command",
  SUBORDINATES: "subordinates",
  SUPERVISOR: "supervisor",
  ORGANIZATION_STRUCTURE: "organization_structure",
  MOVEMENT: "movement",
};

export const EMPLOYEE_EMPLOYMENT_PAGE_LIST = Object.values(
  EMPLOYEE_EMPLOYMENT_PAGE
);
